
















import { defineComponent, PropType, computed } from '@vue/composition-api'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner, faHourglassStart } from '@fortawesome/free-solid-svg-icons'

library.add(faSpinner)
library.add(faHourglassStart)

import { TShirtSize } from '@/lib/sizing'

import { sizeToFaIconSize } from '@/lib/font-awesome'
import { sizeToFontSize } from '@/lib/tailwind'
import { Orientation } from '@/lib/positioning'

export default defineComponent({
  props: {
    size: {
      type: String as PropType<TShirtSize>,
      default: 'medium'
    },
    color: {
      type: String,
      default: '#333'
    },
    waiting: {
      type: Boolean,
      default: false
    },
    label: String,
    layout: String as PropType<Orientation>
  },
  setup(props) {
    const iconSize = computed(() => sizeToFaIconSize(props.size))
    const fontSize = computed(() => sizeToFontSize(props.size))

    const classes = computed(() => ({
      'flex-row': props.layout === 'horizontal',
      'flex-col': props.layout === 'vertical'
    }))

    return {
      iconSize,
      fontSize,
      classes
    }
  }
})
